import { HttpClientEngineCapability33x11oaa7ywe5 as HttpClientEngineCapability } from '../engine/HttpClientEngineCapability.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
  createThis2j2avj17cvnv2 as createThis,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getKClass3t8tygqu4lcxf as getKClass,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from '../request/ClientUpgradeContent.mjs';
import { isWebsocket1w1xog9vfgwm1 as isWebsocket } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { SSEClientContent14bbfeddoyr65 as SSEClientContent } from './sse/SSEClientContent.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Send_instance2se4t9sd7p3bp as Send_instance,
  Sender1wtdgti85uk42 as Sender,
} from './api/CommonHooks.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { delay3147v9lzv1xxn as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { cancel1xim2hrvjmwpn as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return LOGGER;
}
var LOGGER;
function get_HttpTimeout() {
  _init_properties_HttpTimeout_kt__pucqrr();
  return HttpTimeout;
}
var HttpTimeout;
var HttpTimeoutCapabilityClass;
function HttpTimeoutCapability() {
  if (HttpTimeoutCapabilityClass === VOID) {
    class $ {
      toString() {
        return 'HttpTimeoutCapability';
      }
      hashCode() {
        return 2058496954;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpTimeoutCapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HttpTimeoutCapability', VOID, VOID, [HttpClientEngineCapability()]);
    HttpTimeoutCapabilityClass = $;
  }
  return HttpTimeoutCapabilityClass;
}
var HttpTimeoutCapability_instance;
function HttpTimeoutCapability_getInstance() {
  return HttpTimeoutCapability_instance;
}
var HttpRequestTimeoutExceptionClass;
function HttpRequestTimeoutException() {
  if (HttpRequestTimeoutExceptionClass === VOID) {
    class $ extends IOException() {
      static i5v(url, timeoutMillis, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.j4i('Request timeout has expired [url=' + url + ', request_timeout=' + toString(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', cause);
        captureStack($this, $this.h5v_1);
        $this.f5v_1 = url;
        $this.g5v_1 = timeoutMillis;
        return $this;
      }
      static j5v(request) {
        var tmp = request.n5j_1.y56();
        var tmp0_safe_receiver = request.k5v(HttpTimeoutCapability_instance);
        return this.i5v(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o5v());
      }
      n13() {
        return HttpRequestTimeoutException().i5v(this.f5v_1, this.g5v_1, this.cause);
      }
    }
    initMetadataForClass($, 'HttpRequestTimeoutException', VOID, VOID, [CopyableThrowable()]);
    HttpRequestTimeoutExceptionClass = $;
  }
  return HttpRequestTimeoutExceptionClass;
}
function checkTimeoutValue($this, value) {
  // Inline function 'kotlin.require' call
  if (!(value == null || value > 0n)) {
    var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeoutConfig.INFINITE_TIMEOUT_MS';
    throw IllegalArgumentException().n2(toString(message));
  }
  return value;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.p5v_1 = 9223372036854775807n;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'TimeoutConfiguration';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(HttpTimeoutConfig());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(HttpTimeoutConfig()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.q5v_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function init_io_ktor_client_plugins_HttpTimeoutConfig(_this__u8e3s4) {
  Companion_getInstance();
  _this__u8e3s4.l5v_1 = 0n;
  _this__u8e3s4.m5v_1 = 0n;
  _this__u8e3s4.n5v_1 = 0n;
}
var HttpTimeoutConfigClass;
function HttpTimeoutConfig() {
  if (HttpTimeoutConfigClass === VOID) {
    class $ {
      static r5v(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
        Companion_getInstance();
        requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
        connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
        socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
        var $this = createThis(this);
        init_io_ktor_client_plugins_HttpTimeoutConfig($this);
        $this.s5v(requestTimeoutMillis);
        $this.t5v(connectTimeoutMillis);
        $this.u5v(socketTimeoutMillis);
        return $this;
      }
      s5v(value) {
        this.l5v_1 = checkTimeoutValue(this, value);
      }
      o5v() {
        return this.l5v_1;
      }
      t5v(value) {
        this.m5v_1 = checkTimeoutValue(this, value);
      }
      v5v() {
        return this.m5v_1;
      }
      u5v(value) {
        this.n5v_1 = checkTimeoutValue(this, value);
      }
      w5v() {
        return this.n5v_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof HttpTimeoutConfig()))
          THROW_CCE();
        if (!(this.l5v_1 == other.l5v_1))
          return false;
        if (!(this.m5v_1 == other.m5v_1))
          return false;
        if (!(this.n5v_1 == other.n5v_1))
          return false;
        return true;
      }
      hashCode() {
        var tmp0_safe_receiver = this.l5v_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getBigIntHashCode(tmp0_safe_receiver);
        var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp = imul(31, result);
        var tmp2_safe_receiver = this.m5v_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : getBigIntHashCode(tmp2_safe_receiver);
        result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
        var tmp_0 = imul(31, result);
        var tmp4_safe_receiver = this.n5v_1;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : getBigIntHashCode(tmp4_safe_receiver);
        result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'HttpTimeoutConfig', $.r5v);
    HttpTimeoutConfigClass = $;
  }
  return HttpTimeoutConfigClass;
}
function get_supportsRequestTimeout(_this__u8e3s4) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var tmp;
  var tmp_0;
  if (!isWebsocket(_this__u8e3s4.n5j_1.o55())) {
    var tmp_1 = _this__u8e3s4.q5j_1;
    tmp_0 = !(tmp_1 instanceof ClientUpgradeContent());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_2 = _this__u8e3s4.q5j_1;
    tmp = !(tmp_2 instanceof SSEClientContent());
  } else {
    tmp = false;
  }
  return tmp;
}
function applyRequestTimeout(_this__u8e3s4, request, requestTimeout) {
  _init_properties_HttpTimeout_kt__pucqrr();
  if (requestTimeout == null || requestTimeout === 9223372036854775807n)
    return Unit_instance;
  var executionContext = request.r5j_1;
  var tmp = new (CoroutineName())('request-timeout');
  var killer = launch(_this__u8e3s4, tmp, VOID, applyRequestTimeout$slambda_0(requestTimeout, request, executionContext));
  var tmp_0 = request.r5j_1;
  tmp_0.gx((it) => {
    killer.ox();
    return Unit_instance;
  });
}
function HttpTimeoutConfig$_init_$ref_dl1k0m() {
  return () => HttpTimeoutConfig().r5v();
}
function HttpTimeout$lambda($this$createClientPlugin) {
  _init_properties_HttpTimeout_kt__pucqrr();
  var requestTimeoutMillis = $this$createClientPlugin.q5o_1.o5v();
  var connectTimeoutMillis = $this$createClientPlugin.q5o_1.v5v();
  var socketTimeoutMillis = $this$createClientPlugin.q5o_1.w5v();
  var tmp = Send_instance;
  $this$createClientPlugin.t5o(tmp, HttpTimeout$lambda$slambda_0(connectTimeoutMillis, socketTimeoutMillis, requestTimeoutMillis));
  return Unit_instance;
}
function invoke$hasNotNullTimeouts(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, supportsRequestTimeout) {
  return supportsRequestTimeout && !(requestTimeoutMillis == null) || !(connectTimeoutMillis == null) || !(socketTimeoutMillis == null);
}
var HttpTimeout$lambda$slambdaClass;
function HttpTimeout$lambda$slambda() {
  if (HttpTimeout$lambda$slambdaClass === VOID) {
    class $ {
      constructor($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis) {
        this.x5v_1 = $connectTimeoutMillis;
        this.y5v_1 = $socketTimeoutMillis;
        this.z5v_1 = $requestTimeoutMillis;
      }
      *h5r($this$on, request, $completion) {
        var supportsRequestTimeout = get_supportsRequestTimeout(request);
        var configuration = request.k5v(HttpTimeoutCapability_instance);
        if (configuration == null && invoke$hasNotNullTimeouts(this.z5v_1, this.x5v_1, this.y5v_1, supportsRequestTimeout)) {
          configuration = HttpTimeoutConfig().r5v();
          request.a5w(HttpTimeoutCapability_instance, configuration);
        }
        var tmp0_safe_receiver = configuration;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp0_elvis_lhs = tmp0_safe_receiver.v5v();
          tmp0_safe_receiver.t5v(tmp0_elvis_lhs == null ? this.x5v_1 : tmp0_elvis_lhs);
          var tmp1_elvis_lhs = tmp0_safe_receiver.w5v();
          tmp0_safe_receiver.u5v(tmp1_elvis_lhs == null ? this.y5v_1 : tmp1_elvis_lhs);
          if (supportsRequestTimeout) {
            var tmp2_elvis_lhs = tmp0_safe_receiver.o5v();
            tmp0_safe_receiver.s5v(tmp2_elvis_lhs == null ? this.z5v_1 : tmp2_elvis_lhs);
            applyRequestTimeout($this$on, request, tmp0_safe_receiver.o5v());
          }
        }
        return yield* $this$on.k5r(request, $completion);
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof Sender() ? p1 : THROW_CCE();
        return this.h5r(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpTimeout$lambda$slambdaClass = $;
  }
  return HttpTimeout$lambda$slambdaClass;
}
function HttpTimeout$lambda$slambda_0($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis) {
  var i = new (HttpTimeout$lambda$slambda())($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis);
  var l = ($this$on, request, $completion) => i.h5r($this$on, request, $completion);
  l.$arity = 2;
  return l;
}
var applyRequestTimeout$slambdaClass;
function applyRequestTimeout$slambda() {
  if (applyRequestTimeout$slambdaClass === VOID) {
    class $ {
      constructor($requestTimeout, $request, $executionContext) {
        this.b5w_1 = $requestTimeout;
        this.c5w_1 = $request;
        this.d5w_1 = $executionContext;
      }
      *b1g($this$launch, $completion) {
        yield* delay(this.b5w_1, $completion);
        var cause = HttpRequestTimeoutException().j5v(this.c5w_1);
        // Inline function 'io.ktor.util.logging.trace' call
        var this_0 = get_LOGGER();
        if (get_isTraceEnabled(this_0)) {
          var tmp$ret$1 = 'Request timeout: ' + this.c5w_1.n5j_1.toString();
          this_0.d4u(tmp$ret$1);
        }
        cancel(this.d5w_1, ensureNotNull(cause.message), cause);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.b1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    applyRequestTimeout$slambdaClass = $;
  }
  return applyRequestTimeout$slambdaClass;
}
function applyRequestTimeout$slambda_0($requestTimeout, $request, $executionContext) {
  var i = new (applyRequestTimeout$slambda())($requestTimeout, $request, $executionContext);
  var l = ($this$launch, $completion) => i.b1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_HttpTimeout_kt_9oyjbd;
function _init_properties_HttpTimeout_kt__pucqrr() {
  if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
    properties_initialized_HttpTimeout_kt_9oyjbd = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
    var tmp = HttpTimeoutConfig$_init_$ref_dl1k0m();
    HttpTimeout = createClientPlugin('HttpTimeout', tmp, HttpTimeout$lambda);
  }
}
//region block: init
HttpTimeoutCapability_instance = new (HttpTimeoutCapability())();
//endregion
//region block: exports
export {
  HttpTimeoutCapability_instance as HttpTimeoutCapability_instancec8hwguxy67pm,
  HttpRequestTimeoutException as HttpRequestTimeoutException19335ch7q7rkf,
  get_HttpTimeout as get_HttpTimeout3mcrbvfnvmyx2,
};
//endregion

//# sourceMappingURL=HttpTimeout.mjs.map
